var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaintBall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 14.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5L2 10.5L3 12L6.5 10.5L9 5L6.5 4L4 6.5Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.2122V18.5616C12 17.6438 12.6246 16.8439 13.5149 16.6213L16.5624 15.8594C17.4164 15.6459 18.3095 16.0159 18.7624 16.7707L20.2949 19.3249C20.7199 20.0331 20.6657 20.9298 20.1586 21.5817L18.4692 23.7539C17.9009 24.4845 16.9055 24.7298 16.0629 24.3468L13.1724 23.0329C12.4584 22.7084 12 21.9965 12 21.2122Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5379 6.46087L19.0121 4.68076C18.4641 4.04146 18.5705 3.07211 19.2441 2.56691C19.7039 2.22205 20.3235 2.17973 20.8259 2.45886L24.2551 4.36397C24.4176 4.45422 24.5667 4.56666 24.6981 4.69807L26.8626 6.86257C27.1762 7.17616 27.0904 7.70481 26.6937 7.90314C26.568 7.96601 26.4252 7.98641 26.2869 7.96126L21.6986 7.12702C21.2467 7.04485 20.8368 6.80962 20.5379 6.46087Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.2122V18.5616C12 17.6438 12.6246 16.8439 13.5149 16.6213L16.5624 15.8594C17.4164 15.6459 18.3095 16.0159 18.7624 16.7707L20.2949 19.3249C20.7199 20.0331 20.6657 20.9298 20.1586 21.5817L18.4692 23.7539C17.9009 24.4845 16.9055 24.7298 16.0629 24.3468L13.1724 23.0329C12.4584 22.7084 12 21.9965 12 21.2122Z",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5379 6.46087L19.0121 4.68076C18.4641 4.04146 18.5705 3.07211 19.2441 2.56691C19.7039 2.22205 20.3235 2.17973 20.8259 2.45886L24.2551 4.36397C24.4176 4.45422 24.5667 4.56666 24.6981 4.69807L26.8626 6.86257C27.1762 7.17616 27.0904 7.70481 26.6937 7.90314C26.568 7.96601 26.4252 7.98641 26.2869 7.96126L21.6986 7.12702C21.2467 7.04485 20.8368 6.80962 20.5379 6.46087Z",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15.5C30 23.5077 23.5077 30 15.5 30C7.4923 30 1 23.5091 1 15.5C1 7.49088 7.4923 1 15.5 1C16.8889 1 18.2337 1.19476 19.506 1.5601C25.5661 3.29868 30 8.88118 30 15.5Z",
    stroke: "black",
    strokeWidth: 1.72619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54395 10.8085C6.54395 10.8085 7.25473 7.25455 9.24493 5.40651C11.2351 3.55847 16.2106 3.41631 17.0636 3.55847C17.9165 3.70063 21.1861 7.39671 21.1861 7.39671L18.343 15.0732L11.8038 16.3526L6.54395 10.8085Z",
    stroke: "black",
    strokeWidth: 1.72619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54384 10.8086C6.54384 10.8086 3.13208 11.8037 2.56345 12.7988C1.99482 13.7939 1.71051 19.9066 2.13698 20.6174C2.56345 21.3282 5.97521 24.4557 5.97521 24.4557C5.97521 24.4557 6.07899 26.5738 6.52536 26.9363",
    stroke: "black",
    strokeWidth: 1.72619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27958 9.53027C2.27958 9.53027 2.13742 11.5205 2.56389 12.7999",
    stroke: "black",
    strokeWidth: 1.72619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97656 24.4555L11.3785 22.3231L11.805 16.3525",
    stroke: "black",
    strokeWidth: 1.72619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3298 14.916L21.7544 20.3336L17.3475 25.1669L11.377 22.3238",
    stroke: "black",
    strokeWidth: 1.72619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.475 29.7174L17.3477 25.167",
    stroke: "black",
    strokeWidth: 1.72619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7542 20.3331L27.7248 19.7645C27.7248 19.7645 29.8571 14.789 29.715 13.3675C29.5728 11.9459 25.8767 7.68118 25.0238 7.39687C24.1708 7.11256 21.1855 7.39687 21.1855 7.39687",
    stroke: "black",
    strokeWidth: 1.72619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5742 23.5076C27.5742 23.5076 28.1528 20.4754 27.7263 19.7646",
    stroke: "black",
    strokeWidth: 1.72619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0635 3.5599C17.0635 3.5599 18.3727 1.83554 20.063 1.77441",
    stroke: "black",
    strokeWidth: 1.72619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1677 7.39752C25.1677 7.39752 24.5962 4.51884 23.6025 3.46973",
    stroke: "black",
    strokeWidth: 1.72619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3875 5.12205C8.48765 4.79083 7.58638 4.45818 6.68652 4.12695",
    stroke: "black",
    strokeWidth: 1.72619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintBall);
export default __webpack_public_path__ + "static/media/paint-ball.954c51acc9455e3c3ce4029ff45da228.svg";
export { ForwardRef as ReactComponent };